import { isEmpty } from 'lodash';

function removeMask(value) {
  return isEmpty(value) ? value : value.replace(/\D+/g, '');
}

export const removeCpfCnpjMask = (value) => {
  return isEmpty(value)
    ? value
    : value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
};

/**
 *
 * @param {Event} event
 * @param {'CNPJ'} type
 * @returns {string | undefined}
 */
export function removeMaskFromEvent({ target: { value } }, type = null) {
  if (type === 'CNPJ') return removeCpfCnpjMask(value);
  return removeMask(value);
}

export function removePlateMask(value) {
  return isEmpty(value) ? value : value.replace(/-/g, '');
}

export default removeMask;
